/** Spec §4 — folder template per customer. The customer root is `{account_number}`. */
export const CUSTOMER_FOLDER_TEMPLATE = [
    { name: 'Credit', documentTypes: ['CREDIT_APP', 'PERS_GUAR', 'FINANCIAL'], defaultRoles: ['Credit.Analyst'] },
    { name: 'Compliance', documentTypes: ['RESALE_CERT', 'W9'], defaultRoles: ['Credit.Analyst', 'AR.Specialist', 'Sales.Branch'] },
    { name: 'Legal', documentTypes: ['LEGAL'], defaultRoles: ['Credit.Analyst', 'AR.Specialist'] },
    { name: 'Other', documentTypes: ['CUSTOMER_OTHER'], defaultRoles: ['Credit.Analyst', 'AR.Specialist', 'Sales.Branch'] },
    { name: 'Jobs', documentTypes: [], defaultRoles: ['AR.Specialist', 'Sales.Branch'], perSite: 'open' },
    { name: 'Archive', documentTypes: [], defaultRoles: ['AR.Specialist', 'Sales.Branch'], perSite: 'archived' },
];
/** Document types inside each `Jobs/{job_reference}` and `Archive/{job_reference}` folder. */
export const SITE_DOCUMENT_TYPES = ['PRELIM', 'LIEN_REL_COND', 'LIEN_REL_UNCOND', 'JOB_INFO', 'BID_REQ', 'JOB_DOC'];
/** Spec §4 — folder template per supplier. The supplier root is `{supplier_number}`. */
export const SUPPLIER_FOLDER_TEMPLATE = [
    { name: 'Financial', documentTypes: ['SUPPLIER_W9', 'SUPPLIER_TIN', 'SUPPLIER_BANK'], defaultRoles: ['Purchasing'] },
    { name: 'Insurance', documentTypes: ['SUPPLIER_INS'], defaultRoles: ['Purchasing'] },
    { name: 'Contracts', documentTypes: ['SUPPLIER_CONTRACT'], defaultRoles: ['Purchasing'] },
    { name: 'Archive', documentTypes: ['SUPPLIER_ARCHIVE'], defaultRoles: ['Purchasing'] },
    { name: 'Other', documentTypes: ['SUPPLIER_OTHER'], defaultRoles: ['Purchasing'] },
];
export function folderTemplateFor(entityType) {
    switch (entityType) {
        case 'customer':
            return CUSTOMER_FOLDER_TEMPLATE;
        case 'supplier':
            return SUPPLIER_FOLDER_TEMPLATE;
        case 'site':
            return [];
    }
}
/** Job folder display name (D4): the AR job reference, with the site id as a fallback. */
export function siteFolderName(jobReference, siteId) {
    const ref = (jobReference ?? '').trim();
    return ref.length > 0 ? ref : `Site ${siteId}`;
}
/** Job references that sort ahead of every other job folder, in this order (compared trimmed, case-insensitively). */
export const PINNED_JOB_NAMES = ['misc', 'holding'];
const naturalCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
/**
 * Order for job folders / job lists: Misc first, then Holding (any case), then everything else in
 * case-insensitive natural order ("2 Elm" before "10 Oak"). On DEV4 4,364 of 11,166 referenced
 * sites are "Misc" and 503 "Holding", one of each per customer, so pinning them keeps the per-job
 * folders together below. Longer references that merely contain the words ("Misc - Ag") are real
 * jobs and sort with the rest.
 */
export function compareJobNames(a, b) {
    const na = a.trim();
    const nb = b.trim();
    const pa = PINNED_JOB_NAMES.indexOf(na.toLowerCase());
    const pb = PINNED_JOB_NAMES.indexOf(nb.toLowerCase());
    if (pa !== -1 || pb !== -1) {
        if (pa === -1)
            return 1;
        if (pb === -1)
            return -1;
        if (pa !== pb)
            return pa - pb;
    }
    return naturalCollator.compare(na, nb);
}
//# sourceMappingURL=folder-templates.js.map